import { getOr } from 'lodash/fp'
import { createSectionCreator, createField } from './utils'
import { get } from 'lodash'
import { getInsured } from './selectors'

const videoConsentField = (app, id) => {
  const insuredInfo = getInsured(app)
  const insuredEmail = get(insuredInfo, 'email', '')
  const insuredMobileNo = get(insuredInfo, 'mobileNumber', '')
  const currentContact = get(app, ['ekycInfo', 'sendLink', 'textInput'], insuredMobileNo)
  const method = get(app, ['ekycInfo', 'sendLink', 'method'], 'sms')
  const caseId =
    getOr(null, `ekycInfo.insured.caseId`, app) ||
    getOr(null, `ekycInfo.payer.caseId`, app) ||
    getOr(null, `remoteSelling.ekyc.caseId`, app)
  const isInCall = get(app, ['remoteSelling', 'callStatus', 'isInCall'], false)
  const applicationStatus = get(app, ['status'], '')
  return [
    createField(`${id}.videoConsent`, [
      {
        id: `${id}-${caseId}-${isInCall}.videoConsent`,
        c: 'VideoConsent',
        p: {
          isInCall,
          applicationStatus,
        },
      },
    ]),
  ]
}

export default createSectionCreator(videoConsentField)
